import script from "./OrderDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetail.vue?vue&type=style&index=0&id=92aa5d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92aa5d04"]])

export default __exports__